import { CATEGORIES } from '../lib/constants'

// Shown wherever a listing has no photo. Full tiles show the category icon
// and the listing title; thumbnails (pass `size`) show just the icon.
export default function ListingPlaceholder({ listing, size = null, large = false, radius = 0 }) {
const cat = CATEGORIES.find(c => c.id === listing?.category_id)
const icon = cat?.icon || '📦'
const background = 'linear-gradient(135deg, var(--primary-light) 0%, var(--accent-light) 100%)'

if (size) {
return (
<div aria-hidden="true" style={{ width: size, height: size, borderRadius: radius, background, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: Math.round(size * 0.5), flexShrink: 0 }}>
{icon}
</div>
)
}

const badge = large ? 96 : 64
return (
<div style={{ width: '100%', height: '100%', borderRadius: radius, background, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: large ? 16 : 10, padding: '12px 16px', textAlign: 'center' }}>
<div aria-hidden="true" style={{ width: badge, height: badge, borderRadius: '50%', background: 'white', boxShadow: 'var(--shadow-sm)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: Math.round(badge * 0.5), lineHeight: 1 }}>
{icon}
</div>
{listing?.title && (
<div style={{ maxWidth: '90%', color: 'var(--navy)', fontSize: large ? 18 : 14, fontWeight: 600, lineHeight: 1.3, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', wordBreak: 'break-word' }}>
{listing.title}
</div>
)}
</div>
)
}
